module.exports = __webpack_public_path__ + "media/press/bla2-23622982.png";